module.exports = __webpack_public_path__ + "img/Chinese13-Board.b0c0099a.png";